import {
  AGE_ID,
  ALL_FA_PROGRAMS,
  ALL_WAYS_TO_PLAY,
  CLUB,
  CLUB_CASUAL,
  DISABILITY_OPTION_ID,
  DISABILITY_TYPE,
  DISABILITY_TYPE_ID,
  DISTANCE_ID,
  FA_PROGRAMS,
  FOOTBALL_TYPE_ID,
  FOOTBALL_TYPE_ID_NONE_ALL_SELECTION,
  KICKABOUT_CASUAL,
  LATITUDE_ID,
  LONGITUDE_ID,
  OPT_CURRENT_LOCATION_ID,
  PAGE_NUMBER,
  PAGE_NUMBER_VALUE,
  PAGE_SIZE,
  PAGE_SIZE_VALUE,
  PLAY_WITH_ID,
  SEARCH_FOR_ID,
  Ways_To_Play,
  WEEKDAYS_ID,
  YES,
} from '../../const';

export default (selectedAge, footballtype, disabilityOption) => {
  const includePrograms =
    footballtype === KICKABOUT_CASUAL || footballtype === CLUB_CASUAL;
  // If disabilityOption indicates YES, default to Nationwide (200 miles)
  const distanceValue = disabilityOption === YES ? 200 : 10;
  return {
    [SEARCH_FOR_ID]: '',
    [AGE_ID]: 0,
    [PLAY_WITH_ID]: '',
    // Boys Under 18 don't see the football type question in the onboarding,
    // this logic will assign a football type under the hood in that case
    [FOOTBALL_TYPE_ID]: selectedAge < 18 ? CLUB : KICKABOUT_CASUAL,
    [FOOTBALL_TYPE_ID_NONE_ALL_SELECTION]: 'All',
    [WEEKDAYS_ID]: '',
    [DISABILITY_OPTION_ID]: '',
    [DISABILITY_TYPE_ID]: [],
    [DISABILITY_TYPE]: '',
    // Default search distance in miles (use constant key)
    [DISTANCE_ID]: distanceValue,
    [OPT_CURRENT_LOCATION_ID]: '',
    [LATITUDE_ID]: '',
    [LONGITUDE_ID]: '',
    ...(includePrograms && {
      [FA_PROGRAMS]: ALL_FA_PROGRAMS, // these are program names saved in database with specific ID's,
      RawPrograms: [],
    }),
    [Ways_To_Play]: ALL_WAYS_TO_PLAY, // these are ways saved in database with specific ID's,
    RawWaysToPlay: [],
    [PAGE_NUMBER]: PAGE_NUMBER_VALUE,
    // [PAGE_SIZE]: footballtype === 1 ? MO_PAGE_SIZE_VALUE : PAGE_SIZE_VALUE,
    [PAGE_SIZE]: PAGE_SIZE_VALUE,
  };
};
